const COHORT_SUFFIX = /_intl_[^_/]+$/

export const stripCohortSuffix = (value: string): string =>
  value ? value.replace(COHORT_SUFFIX, '') : value
